import {
  Button,
  Divider,
  Flex,
  Alert,
  AlertIcon,
  AlertTitle,
  Select,
} from "@chakra-ui/react";
import { useEffect } from "react";

const MembershipApproveDecline = ({
  handleApproval,
  handleDecline,
  error,
  errorsArray,
  loading,
  memberDetails,
  selectedMembershipCategory,
  setSelectedMembershipCategory,
  showApproveDeclineButtons = true,
}) => {
  const IndividualMembershipCategory = {
    // STUDENT: "Student",
    AFFILIATE: "Affiliate",
    TECHNOLOGIST: "Technologist",
    GRADUATE: "Graduate",
    ASSOCIATE: "Associate",
    MEMBER: "Meember",
    FELLOW: "Fellow",
  };

  const CorporateMembershipCategory = {
    Standard: "Standard",
    Bronze: "Bronze",
    Silver: "Silver",
    Gold: "Gold",
    GoldPlus: "GoldPlus",
    Diamond: "Diamond",
    Platinum: "Platinum",
    PlatinumPlus: "PlatinumPlus",
  };

  // const corporateCategory =
  //   "Standard" ||
  //   "Bronze" ||
  //   "Silver" ||
  //   "Gold" ||
  //   "GoldPlus" ||
  //   "Diamond" ||
  //   "Platinum" ||
  //   "PlatinumPlus";

  const isCorporateCategory = Object.keys(CorporateMembershipCategory).includes(
    memberDetails?.currentCategory
  );
  const categoryOptions = isCorporateCategory
    ? CorporateMembershipCategory
    : IndividualMembershipCategory;
  console.log(isCorporateCategory);
  useEffect(() => {
    console.log("showApproveDeclineButtons", showApproveDeclineButtons);
  }, [showApproveDeclineButtons]);
  // console.log("showApproveDeclineButtons", showApproveDeclineButtons);

  return (
    <>
      {error && (
        <Alert status="error" className="mt-3" mb={3}>
          <AlertIcon />
          <AlertTitle>{errorsArray.join(", ")}</AlertTitle>
        </Alert>
      )}
      <Divider border={"1px solid #E3E3E3"} />
      {showApproveDeclineButtons && (
        <Flex
          flexDirection={["column", "row", "row"]}
          justifyContent={"center"}
          alignItems={"center"}
          gap={["20px", "50px", "50px"]}
          my={6}
          fontSize={"16px"}
          fontWeight={"500"}
          fontFamily={"roboto"}
          letterSpacing={"-0.25px"}
          lineHeight={"18.75px"}
        >
          <Select
            placeholder="Assign Membership Category"
            value={selectedMembershipCategory || ""}
            onChange={(e) => {
              const selectedValue = e.target.value;

              setSelectedMembershipCategory(selectedValue);
            }}
            width="300px"
          >
            {Object.entries(categoryOptions).map(([key, value]) => (
              <option key={value} value={value}>
                {key}
              </option>
            ))}
          </Select>
          <Button
            bg={"#61CE70"}
            color={"#FFFFFF"}
            borderRadius={"3px"}
            w={"170px"}
            _hover={{ backgroundColor: "" }}
            _active={{ backgroundColor: "" }}
            onClick={handleApproval}
            isLoading={loading}
            loadingText="Approving ..."
          >
            Approve
          </Button>
          <Button
            bg={"#D11A2A"}
            color={"#ffffff"}
            borderRadius={"3px"}
            w={"170px"}
            _hover={{ backgroundColor: "" }}
            _active={{ backgroundColor: "" }}
            onClick={handleDecline}
          >
            Decline
          </Button>
        </Flex>
      )}
    </>
  );
};

export default MembershipApproveDecline;
